<i [ctrlIcon]="reportDamageButtonIcon()"></i> {{ reportDamageButtonLabel() }}
